import { render, staticRenderFns } from "./QStatsUniqueWritersChart.vue?vue&type=template&id=37be752f&"
import script from "./QStatsUniqueWritersChart.vue?vue&type=script&lang=js&"
export * from "./QStatsUniqueWritersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports